import React, { Component } from 'react';

class Row extends Component {
  render() {
    return (
      <tr className="hover:bg-gray-200 cursor-default">
        {this.props.children}
      </tr>
    );
  }
}

export default Row;

